module.exports = __webpack_public_path__ + "static/background-2-9a9267f28d7c45385e13f02f79e5d18d.svg";